import React from "react";
import ListItem from "@mui/material/ListItem";
import { enqueueSnackbar } from "notistack";
import { useGame, useUpdateGameV2 } from "@seabrookstudios/pitch2table";
import { EditableListItem } from "./EditableListItem";
import Skeleton from "@mui/material/Skeleton";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const GameYearStarted = ({ gameId }) => {
  const { isLoading, data: game } = useGame(gameId);

  const onUpdateSuccess = () => {
    enqueueSnackbar("Saved", { variant: "success" });
  };

  const onUpdateFailure = () => {
    enqueueSnackbar("Update failed", { variant: "error" });
  };

  const updateGame = useUpdateGameV2(gameId, onUpdateSuccess, onUpdateFailure);

  /**
   * @param {number} year
   */
  const updateYear = (year) => {
    if (year <= 0) {
      return;
    }

    updateGame.mutate({ year, sizzle: undefined, bgg: undefined, personalGoal: undefined });
  };

  return (
    <ListItem>
      <EditableListItem
        helperText="The year you started this project. Purely informational"
        onSave={updateYear}
        text={isLoading || !game ? <Skeleton /> : game.year}
        title="Year Started"
        disabled={isLoading || !game}
      />
    </ListItem>
  );
};
